import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const Breadcrumb = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);

  // Define breadcrumb labels
  const breadcrumbLabels = {
    'services': 'Services',
    'service-models': 'Service-Pakete',
    'references': 'Referenzen',
    'faq': 'FAQ',
    'contact': 'Kontakt',
    'career': 'Karriere',
    'cyber-risiko-check': 'CyberCheck',
    'datenschutz': 'Datenschutz',
    'impressum': 'Impressum'
  };

  // Don't show breadcrumb on homepage
  if (pathnames.length === 0) {
    return null;
  }

  // Generate breadcrumb items
  const breadcrumbItems = [
    { 
      label: 'Home', 
      path: '/',
      icon: <Home className="h-3 w-3" />
    }
  ];

  let currentPath = '';
  pathnames.forEach((segment, index) => {
    currentPath += `/${segment}`;

    breadcrumbItems.push({
      label: breadcrumbLabels[segment] || segment,
      path: currentPath,
      isLast: index === pathnames.length - 1
    });
  });

  return (
    <nav 
      aria-label="Breadcrumb" 
      className="py-2 px-4 sm:px-6 lg:px-8 bg-gray-50 border-b"
    >
      <div className="container mx-auto">
        <ol className="flex items-center space-x-1 sm:space-x-2 text-xs sm:text-sm overflow-x-auto">
          {breadcrumbItems.map((item, index) => (
            <li key={index} className="flex items-center">
              {index > 0 && (
                <ChevronRight className="h-3 w-3 text-gray-400 mx-2" />
              )}
              
              {item.isLast ? (
                <span 
                  className="text-gray-600 font-medium flex items-center"
                  aria-current="page"
                >
                  {item.icon && <span className="mr-2">{item.icon}</span>}
                  {item.label}
                </span>
              ) : (
                <Link
                  to={item.path}
                  className="text-gray-500 hover:text-blue-600 transition-colors flex items-center"
                >
                  {item.icon && <span className="mr-2">{item.icon}</span>}
                  {item.label}
                </Link>
              )}
            </li>
          ))}
        </ol>
      </div>

      {/* Structured Data for Breadcrumbs */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": breadcrumbItems.map((item, index) => ({
            "@type": "ListItem",
            "position": index + 1,
            "name": item.label,
            "item": `https://netsyte.de${item.path}`
          }))
        })}
      </script>
    </nav>
  );
};

export default Breadcrumb;